/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RecordingManualChangesResponseFieldsContributionsItemsInner } from './RecordingManualChangesResponseFieldsContributionsItemsInner';
import {
    RecordingManualChangesResponseFieldsContributionsItemsInnerFromJSON,
    RecordingManualChangesResponseFieldsContributionsItemsInnerFromJSONTyped,
    RecordingManualChangesResponseFieldsContributionsItemsInnerToJSON,
} from './RecordingManualChangesResponseFieldsContributionsItemsInner';

/**
 * 
 * @export
 * @interface RecordingManualChangesResponseFieldsContributions
 */
export interface RecordingManualChangesResponseFieldsContributions {
    /**
     * 
     * @type {Array<RecordingManualChangesResponseFieldsContributionsItemsInner>}
     * @memberof RecordingManualChangesResponseFieldsContributions
     */
    items: Array<RecordingManualChangesResponseFieldsContributionsItemsInner>;
}

/**
 * Check if a given object implements the RecordingManualChangesResponseFieldsContributions interface.
 */
export function instanceOfRecordingManualChangesResponseFieldsContributions(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;

    return isInstance;
}

export function RecordingManualChangesResponseFieldsContributionsFromJSON(json: any): RecordingManualChangesResponseFieldsContributions {
    return RecordingManualChangesResponseFieldsContributionsFromJSONTyped(json, false);
}

export function RecordingManualChangesResponseFieldsContributionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecordingManualChangesResponseFieldsContributions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(RecordingManualChangesResponseFieldsContributionsItemsInnerFromJSON)),
    };
}

export function RecordingManualChangesResponseFieldsContributionsToJSON(value?: RecordingManualChangesResponseFieldsContributions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(RecordingManualChangesResponseFieldsContributionsItemsInnerToJSON)),
    };
}

